// extracted by mini-css-extract-plugin
export default {"wrapper":"Menu_wrapper__GzvTg","logo":"Menu_logo__cSg4y","mobileMenu":"Menu_mobileMenu__g+NTz","link":"Menu_link__xRCEx","active":"Menu_active__96thA","close":"Menu_close__ST1M2"};